var _rect, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPasswordIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 36,
    viewBox: "0 0 76 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.66602,
    y: 2.66669,
    width: 70.6667,
    height: 30.6667,
    rx: 15.3333,
    stroke: "#E3E8FF",
    strokeWidth: 4
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.334,
    cy: 18,
    r: 4,
    fill: "#E3E8FF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 18,
    r: 4,
    fill: "#E3E8FF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 56.666,
    cy: 18,
    r: 4,
    fill: "#E3E8FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordIllustration);
export default __webpack_public_path__ + "static/media/passwordIllustration.e51dffb47bb03ae94c8adb8379b49d38.svg";
export { ForwardRef as ReactComponent };